/**
 * Lazy Load Module
 */
export class LazyLoad {
    constructor() {
        this.observer = null;
    }
    init() {
        if ('IntersectionObserver' in window) {
            this.observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        this.loadImage(entry.target);
                        this.observer?.unobserve(entry.target);
                    }
                });
            }, { rootMargin: '50px 0px' });
            document.querySelectorAll('img[data-src]').forEach((img) => {
                this.observer?.observe(img);
            });
        }
        else {
            // Fallback for older browsers
            document.querySelectorAll('img[data-src]').forEach((img) => {
                this.loadImage(img);
            });
        }
    }
    loadImage(img) {
        const src = img.getAttribute('data-src');
        if (src) {
            img.src = src;
            img.removeAttribute('data-src');
            img.classList.add('loaded');
        }
    }
}
export default LazyLoad;
